export default class CountUp {

	/** @var {HTMLElement} */
	element;

	/** @var {Number} */
	startValue;

	/** @var {Number} */
	endValue;

	/** @var {Number} */
	duration;

	/** @var {Number} */
	startTime;


	/**
	 * @param {HTMLElement} element
	 */
	constructor(element) {
		if (!element.dataset.start || !element.dataset.end || !element.dataset.duration) {
			return;
		}
		this.element = element;
		this.startValue = Number(element.dataset.start);
		this.endValue = Number(element.dataset.end);
		this.duration = Number(element.dataset.duration) * 1000;
		this.frame = this.frame.bind(this);

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					observer.unobserve(entry.target);
					requestAnimationFrame(this.frame);
				}
			});
		});
		observer.observe(this.element);
	}

	/**
	 *
	 * @param {DOMHighResTimeStamp} now
	 */
	frame(now) {
		if (this.startTime === undefined) {
			this.startTime = now;
		}
		const elapsed = now - this.startTime;
		const progress = Math.min(elapsed / this.duration, 1);
		const eased = 1 - Math.pow(1 - progress, 3);
		const value = Math.round(this.startValue + (this.endValue - this.startValue) * eased);
		this.element.textContent = value.toLocaleString();
		if (progress < 1) {
			requestAnimationFrame(this.frame);
		}
	}

}
